import { routes } from '../routes';

/**
 * Where the senior flow goes once a package is in the cart — the add-ons chain:
 * Announcements & Gifts when the school has a gifts pricelist, else senior
 * add-ons, else retouching.
 *
 * ONE implementation shared by every way a package can land in the cart: the
 * built print package, the "All Digital" fast path, and the $99 Buy-All upsell.
 * The fast paths used to jump straight to review, which skipped the
 * announcements screen entirely — so an all-digital senior never saw the
 * offer's free announcements ("GRAD27: 20% off + 25 free grad announcements")
 * even though the coupon grants them (2026-07-27).
 *
 * `orderPackageId` is the package the add-on sheets attach to (the built print
 * package, or the buy-all order package the server created).
 */
export default function afterBuildRoute({
  giftPricelist, addons, orderPackageId, packageId,
}) {
  if (giftPricelist) {
    return routes.holiday.builder({ optional: true, o: orderPackageId, pid: packageId });
  }
  if (!addons || addons.length === 0) return routes.retouching(orderPackageId);
  return routes.seniors.addons(orderPackageId);
}
